import { HTTP_TOKEN } from "./http";

export const getRateStores = (params) => {
  return HTTP_TOKEN.get("ratestore", { params }).then((result) => {
    return result.data;
  });
};

export const getRatestore = (ratestoreId) => {
  return HTTP_TOKEN.get(`ratestore/${ratestoreId}`).then((result) => {
    return result.data;
  });
};



export const createRatestore = (data) => {
  return HTTP_TOKEN.post("ratestore", data).then((result) => {
    return result.data;
  });
};

export const updateRatestore = (ratestoreId, params) => {
  return HTTP_TOKEN.put(`ratestore/${ratestoreId}`, { params }).then((result) => {
    return result.data;
  });
};

export const deleteRatestore = (ratestoreId) => {
  return HTTP_TOKEN.delete(`ratestore/${ratestoreId}`, {}).then((result) => {
    return result.data;
  });
};
